import { render, staticRenderFns } from "./DonutModule.vue?vue&type=template&id=1d488584&scoped=true&"
import script from "./DonutModule.vue?vue&type=script&lang=js&"
export * from "./DonutModule.vue?vue&type=script&lang=js&"
import style0 from "./DonutModule.vue?vue&type=style&index=0&id=1d488584&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d488584",
  null
  
)

export default component.exports